export const Logo = ({ size = 44 }) => (
  <img
    src="/assets/logo.png"
    alt="Escudo oficial Soccer Trainer 2011"
    data-testid="logo-shield"
    style={{ height: size, width: "auto" }}
    className="object-contain"
  />
);
